import React,{Component} from 'react'
import BoardItem from '../component/BoardItem'
import {Table} from 'antd'
import {awardList} from '../../../api/api'
import './style.less'

export default class BarRecorc extends Component {
	constructor () {
		super()
		this.state = {
			isLoading: false,
			params: {
        pageNum: 0,
        pageSize: 10,
			},
			list: [],
			pageData: {
        total: 0, 
        current: 1, 
      },
		}
	}
	componentDidMount () {
		const {params} = this.state
		this.loadData(params)
	}

	loadData = (params) => {
		this.setState ({isLoading:true})
		awardList(params)
			.then(res => {
				this.setState({
					list: res.data.content,
					isLoading: false,
					pageData: {
						total: res.data.totalElements,
						current: res.data.pageable.pageNumber+1,
						pageSize: res.data.pageable.pageSize
					}
				})
			})
			.catch(err => {
				this.setState({
					list: [],
					isLoading: false,
					pageData: {
						total: 0,
						current: 0,
						pageSize: 0
					}
				})
			})
	}
	//分页
	onPageChange = (e) => {
		const {params} = this.state
		params.pageNum = e.current -1
		this.loadData(params)
	}
  render () {
		const {isLoading, pageData, list} = this.state
		const columns = [
			{
				title: '用户',
				dataIndex: 'user.nickname',
				key: 'nickname',
				align: 'center'
			},
			{
				title: '派送积分',
				dataIndex: 'award',
				key: 'award',
				align: 'center'
			},
			{
				title: '日期',
				dataIndex: 'createAt',
				key: 'createAt',
				align: 'center'
			}
		]
    return (
      <div className="merchants-page">
        <div className="board">
					<BoardItem icon='pay-circle' itemKey='派送总额' itemValue='0' />
        </div>
				<div className="tablecontain">
					<Table
						loading={isLoading}
						bordered 
						columns={columns} 
						dataSource={list} 
						rowKey="id"
						pagination={{
							current: pageData.current,
							total: pageData.total,
							pageSize: pageData.pageSize,
						}}
						onChange={this.onPageChange}
					/>
				</div>
      </div>
    )
  }
}